import React, {useState} from 'react';
import {GoPin} from 'react-icons/go';
import {GrDownload} from 'react-icons/gr';
import {IoMdEye} from 'react-icons/io';
import moment from 'moment';
import toast from 'react-hot-toast';

import SelectField from './ui/SelectField';
import {stageOptions} from '../utils/constants';
import {generatePDF, getFormatedPhoneNumber} from '../utils';
import {useCanidateJobUpdateMutation} from '../api/candidate';
import {invalidateQueryV2} from '../services/reactQuery/index';
import ResumePreviewModal from './ResumePreviewModal';

const CompanyDetails = ({label, value}) => (
  <div className="grid grid-cols-[30%_70%]">
    <div className="font-medium capitalize">{label}</div>
    <div>{value}</div>
  </div>
);

const UserDetails = ({isCandidate, userDetails, loading}) => {
  const [isResumePreviewOpen, setIsResumePreviewOpen] = useState(false);
  const candidateJobUpdateMutation = useCanidateJobUpdateMutation();

  if (loading && !userDetails) return 'Loading...';

  const {
    firstName,
    lastName,
    email,
    phone,

    applicationDate = null,
    job = null,
    stage = null,

    role = null,

    city = null,
    country = null,
    state = null,

    company = [],
    _id: id, // if (isCandidate === true) => jobId else employerId
  } = userDetails;

  const jobTitle = job?.title;
  const formatedLocation = [city, state, country].filter(Boolean).join(', ');
  const formatedApplicationDate = moment(applicationDate).format('MM/DD/YYYY');

  const formatedCompanyDetails = company.map((companyData) => {
    const {
      address,
      city,
      country,
      state,
      zipcode,
      name,
      email,
      description,
      size,
      _id,
    } = companyData;

    const buildAddress = `${address}, ${city}, ${state}, ${country}-${zipcode}`;
    return {
      _id,
      name,
      email,
      description,
      size,
      address: buildAddress,
    };
  });

  const handleJobStageChange = (updatedJobStage) => {
    const updatePayload = {
      jobId: id,
      payload: {stage: updatedJobStage},
    };

    const mutationOptions = {
      onSuccess: () => {
        toast.success('Candidate Stage updated');
        invalidateQueryV2(['candidateJobDetails', id]);
      },
      onError: (data) => toast.error(data.response.data.message),
    };

    candidateJobUpdateMutation.mutate(updatePayload, mutationOptions);
  };

  const contentClassName = 'font-medium text-gray-500';

  return (
    <div className="p-5 flex flex-col gap-6">
      <ResumePreviewModal
        isOpen={isResumePreviewOpen}
        onClose={() => setIsResumePreviewOpen(false)}
        title="Resume Preview"
        resumeDetails={userDetails}
        width="lg"
      />

      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-bold capitalize">
          {firstName} {lastName} {!!role && `(${role})`}
        </h1>

        {isCandidate && (
          <p className={contentClassName}>
            Applied for {jobTitle} on {formatedApplicationDate}
          </p>
        )}
      </div>

      <div className="flex items-center gap-3 text-primary-main font-medium">
        <div>{email}</div>
        <div className="pl-3 border-l border-l-gray-400">
          <div>{getFormatedPhoneNumber(phone)}</div>
        </div>
      </div>

      {isCandidate && (
        <div className="flex-between-center border-t border-t-[#00000029] border-b border-b-[#00000029] py-5">
          <div className="font-semibold">Current Stage</div>
          <SelectField
            options={stageOptions}
            className="w-64 bg-white"
            placeholder="Select interview stage"
            defaultValue={
              stageOptions.find(({value}) => +value === +stage) || null
            }
            onChange={(data) => handleJobStageChange(data.value)}
          />
        </div>
      )}

      {!!formatedLocation && (
        <div>
          <div className="font-semibold pb-2">Location</div>
          <div className={contentClassName}>{formatedLocation}</div>
        </div>
      )}

      {!!company.length && (
        <div>
          <div className="font-medium text-xl pb-2">Company details</div>
          <div className="pt-2">
            {formatedCompanyDetails.map(({_id, ...addressObj}) => (
              <div key={_id} className="bg-white p-5 flex flex-col gap-2">
                {Object.entries(addressObj).map(([label, value]) => (
                  <CompanyDetails key={label} value={value} label={label} />
                ))}
              </div>
            ))}
          </div>
        </div>
      )}

      {userDetails?.resume && (
        <div>
          <div className="font-semibold pb-2">CV</div>
          <div className="flex justify-between bg-light-gray py-2 px-4">
            <div className="flex items-center gap-3">
              <GoPin size={18} />
              <div className="text-primary-main">
                <span className="capitalize">
                  {firstName} {lastName}
                </span>
                - CV.pdf
              </div>
            </div>
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={() => setIsResumePreviewOpen(true)}
              >
                <IoMdEye size={23} />
              </button>
              <button
                type="button"
                onClick={() => {
                  setIsResumePreviewOpen(true);
                  setTimeout(() => {
                    generatePDF('view-resume', `${firstName} ${lastName}-CV`);
                    setIsResumePreviewOpen(false);
                  }, 200);
                }}
              >
                <GrDownload size={20} />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDetails;
